import classNames from "classnames";

function ProjectCard({ projectData, className }) {
  const projectSkillsDivs = projectData.skills.map((skill) => (
    <div
      key={skill}
      className="h-4 px-1 mr-1.5 my-1 font-medium skill-label text-[0.6rem] min-w-[25px] text-black flex flex-col justify-center items-center"
    >
      <span
        className="text-ellipsis whitespace-nowrap font-semibold"
        style={{ overflow: "hidden" }}
      >
        {skill}
      </span>
    </div>
  ));
  return (
    <div
      className={classNames(
        "w-[91%] max-w-[290px] h-max text-white rounded-[24px] project-card flex flex-col items-center justify-center overflow-hidden",
        className
      )}
    >
      <div className="w-full h-[30vh] max-h-[160px] min-h-[90px] overflow-hidden select-none">
        <img
          src={projectData.img}
          alt="project pic"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="mb-5">
        <h1 className="text-2xl mt-1">{projectData.title}</h1>
      </div>
      <div className="w-full px-3 text-sm">
        <p>{projectData.desc}</p>
      </div>
      <div className="flex flex-row flex-wrap justify-evenly w-full px-3 my-3.5">
        {projectSkillsDivs}
      </div>
      <div className="w-full px-3 text-xs text-center mb-3">
        {projectData.date}
      </div>
      {projectData.externalLink && (
        <div className="grow flex flex-row justify-center items-center w-full px-3 mt-2 mb-5 select-none">
          <a href={projectData.externalLink} target="_blank" rel="noreferrer">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 9.25V13.75C13 14.1478 12.842 14.5294 12.5607 14.8107C12.2794 15.092 11.8978 15.25 11.5 15.25H3.25C2.85218 15.25 2.47064 15.092 2.18934 14.8107C1.90804 14.5294 1.75 14.1478 1.75 13.75V5.5C1.75 5.10218 1.90804 4.72064 2.18934 4.43934C2.47064 4.15804 2.85218 4 3.25 4H7.75M10.75 1.75H15.25M15.25 1.75V6.25M15.25 1.75L7 10"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      )}
    </div>
  );
}

export default ProjectCard;
